<section class="sav-allstores-page" aria-label="All stores">
  <div class="sav-allstores-wrap">
    <app-breadcrumb [items]="crumbs()" />
    <header class="sav-allstores-hero">
      <h1>Explore all Stores On SAVINGARENA</h1>
      <p>
        Discover amazing deals and exclusive coupons for your favorite stores. browse through our
        list of stores alphabetically or by category.
      </p>
    </header>

    <nav class="sav-allstores-alphabet" aria-label="Filter stores alphabetically">
      @for (item of alphabetNavItems; track item.value) {
        <!-- The fetch starts on hover or on the touch that precedes the tap, so the round trip
             overlaps with the moment before the click rather than following it. -->
        <a
          [routerLink]="item.path"
          [class.sav-allstores-alphabet-link-active]="selectedGroup() === item.value"
          [attr.aria-current]="selectedGroup() === item.value ? 'page' : null"
          (mouseenter)="prefetchGroup(item.value)"
          (touchstart)="prefetchGroup(item.value)"
          (focus)="prefetchGroup(item.value)"
        >
          {{ item.label }}
        </a>
      }
    </nav>

    <div class="sav-allstores-tools">
      <div class="sav-allstores-stats" aria-label="Store totals">
        <p>
          Stores: <strong>{{ storeTotalLabel() }}</strong>
        </p>
        <p>Active Coupons: <strong>{{ activeCouponsLabel() }}</strong></p>
        <p>Active Products: <strong>{{ activeProductsLabel() }}</strong></p>
      </div>

      <form class="sav-allstores-search" role="search" (submit)="$event.preventDefault()">
        <input
          type="search"
          [value]="searchTerm()"
          [placeholder]="selectedSearchPlaceholder()"
          [attr.aria-busy]="
            isSelectedPageLoading() || (isMainSearchActive() && isMainPageLoading())
          "
          aria-label="Search stores"
          (input)="onSearchInput($event)"
        />
        <button type="button" aria-label="Search stores">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18Z"
            ></path>
            <path d="M20 20L16.1 16.1"></path>
          </svg>
        </button>
      </form>
    </div>

    @if (isLetterPage()) {
      <section class="sav-allstores-a-section" [attr.aria-label]="selectedHeading()">
        <h2 class="sav-allstores-featured-title">
          {{ selectedHeading() }}
          @if (selectedStoreTotal() !== null) {
            <span class="sav-allstores-featured-count">{{ selectedStoreTotal() }} Stores</span>
          }
        </h2>
        <p>Every store in this letter group, newest first.</p>

        @if (isSelectedPageLoading()) {
          <div class="sav-allstores-loading" aria-live="polite">Loading stores...</div>
        } @else {
          <div class="sav-allstores-text-grid sav-allstores-text-grid-selected">
            @for (store of selectedStores(); track store.id) {
              <a
                class="sav-trending-store-card sav-trending-store-card-text-only"
                [routerLink]="store.path"
              >
                <span class="sav-store-tile-store-meta sav-store-tile-store-meta-text-only">
                  <span class="sav-store-tile-brand-name">{{ store.name }}</span>
                </span>
              </a>
            }
          </div>

          @if (selectedStores().length === 0) {
            <p class="sav-allstores-empty">No stores found for this section.</p>
          }

          <!--
            Real anchors, not buttons.

            A crawler follows hrefs; it does not click. If these were buttons calling the router,
            every store past the first page would be unreachable — which is the same trap the page
            avoided before by putting all 3,511 of them in one document, at 4.25 MB and 15 seconds.
            `queryParamsHandling` is deliberately absent so a stale search term is not carried into
            a page link.
          -->
          @if (totalPages() > 1) {
            <nav class="sav-allstores-pagination" aria-label="Store list pages">
              @if (currentPage() > 1) {
                <a
                  class="sav-allstores-pagestep"
                  [routerLink]="['/storelist', selectedGroup()!.toLowerCase()]"
                  [queryParams]="pageQuery(currentPage() - 1)"
                  rel="prev"
                  >← Previous</a
                >
              }

              @for (page of pageLinks(); track $index) {
                @if (page === null) {
                  <span class="sav-allstores-pagegap" aria-hidden="true">…</span>
                } @else if (page === currentPage()) {
                  <span class="sav-allstores-pagenum is-current" aria-current="page">{{ page }}</span>
                } @else {
                  <a
                    class="sav-allstores-pagenum"
                    [routerLink]="['/storelist', selectedGroup()!.toLowerCase()]"
                    [queryParams]="pageQuery(page)"
                    >{{ page }}</a
                  >
                }
              }

              @if (currentPage() < totalPages()) {
                <a
                  class="sav-allstores-pagestep"
                  [routerLink]="['/storelist', selectedGroup()!.toLowerCase()]"
                  [queryParams]="pageQuery(currentPage() + 1)"
                  rel="next"
                  >Next →</a
                >
              }
            </nav>
          }
        }
      </section>
    } @else {
      @if (isMainSearchActive()) {
        <section class="sav-allstores-a-section" aria-label="Store search results">
          <h2 class="sav-allstores-featured-title">
            Search Results
            @if (mainSearchTotal() !== null) {
              <span class="sav-allstores-featured-count">{{ mainSearchTotal() }} Stores</span>
            }
          </h2>

          <p>Stores matching your search.</p>
          @if (isMainPageLoading()) {
            <div class="sav-allstores-loading" aria-live="polite">Searching stores...</div>
          } @else {
            <div class="sav-allstores-text-grid sav-allstores-text-grid-selected">
              @for (store of mainSearchStores(); track store.id) {
                <a
                  class="sav-trending-store-card sav-trending-store-card-text-only"
                  [routerLink]="store.path"
                >
                  <span class="sav-store-tile-store-meta sav-store-tile-store-meta-text-only">
                    <span class="sav-store-tile-brand-name">{{ store.name }}</span>
                  </span>
                </a>
              }
            </div>

            @if (mainSearchStores().length === 0) {
              <p class="sav-allstores-empty">No stores found for this search.</p>
            }
          }
        </section>
      } @else {
        @if (isMainPageLoading()) {
          <div class="sav-allstores-loading" aria-live="polite">Loading stores...</div>
        }

        @for (section of featuredLetterSections(); track section.value) {
          <section
            class="sav-allstores-a-section"
            [attr.aria-label]="'Store names start with ' + section.label"
          >
            <h2 class="sav-allstores-featured-title">
              {{ section.heading }}
              <span class="sav-allstores-featured-count">{{ section.totalStores }} Stores</span>
            </h2>
            <p>Newest additions first — open "View More" for the full list.</p>

            <div class="sav-trending-stores-grid">
              @for (store of section.featuredStores; track store.id) {
                <a class="sav-trending-store-card" [routerLink]="store.path">
                  <span class="sav-store-tile-logo-box">
                    <!-- 27 sections × 8 featured logos: all but the first few are far below the
                         fold, so they load on approach (the component's default) rather than
                         competing with the page. The caption below names the store. -->
                    <app-store-logo [logoUrl]="store.logoUrl" [name]="store.name" decorative />
                  </span>
                  <span class="sav-store-tile-divider" aria-hidden="true"></span>
                  <span class="sav-store-tile-store-meta">
                    <span class="sav-store-tile-brand-name">{{ store.name }}</span>
                    <span class="sav-store-tile-count">{{ store.couponsAndDealsCount }}</span>
                  </span>
                </a>
              }
            </div>

            <div class="sav-allstores-text-grid">
              @for (store of section.textOnlyStores; track store.id) {
                <a
                  class="sav-trending-store-card sav-trending-store-card-text-only"
                  [routerLink]="store.path"
                >
                  <span class="sav-store-tile-store-meta sav-store-tile-store-meta-text-only">
                    <span class="sav-store-tile-brand-name">{{ store.name }}</span>
                  </span>
                </a>
              }

              @if (section.showViewMore) {
                <a
                  class="sav-trending-store-card sav-trending-store-card-text-only sav-allstores-view-more-card"
                  [routerLink]="section.viewMorePath"
                >
                  <span
                    class="sav-store-tile-store-meta sav-store-tile-store-meta-text-only sav-allstores-view-more-meta"
                  >
                    <span class="sav-allstores-view-more-btn">View More Store</span>
                  </span>
                </a>
              }
            </div>
          </section>
        }
      }
    }

    <section class="sav-reviews" aria-label="Shopper reviews">
      <header class="sav-reviews-head">
        <div class="sav-reviews-title-wrap">
          <div class="sav-reviews-eyebrow">
            <span aria-hidden="true"></span>
            <p>Social Proof</p>
            <span class="sav-allstores-static-dot" aria-hidden="true"></span>
          </div>
          <h2>
            What shoppers say.<app-dev-flag
              note="Hardcoded testimonials, rating and review count — not admin/API-driven"
            />
          </h2>
          <p>Ratings and written reviews from shoppers who used these offers.</p>
        </div>

        <div class="sav-reviews-controls">
          <div class="sav-reviews-score">
            <div class="sav-score-stars" aria-hidden="true">★★★★★</div>
            <span aria-hidden="true"></span>
            <h3>4.8 / 5.0 <small>(6 Reviews)</small></h3>
          </div>

          <div class="sav-reviews-nav" aria-hidden="true">
            <button type="button" aria-label="Previous review">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                <path
                  d="M15 19L8 12L15 5"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
            <button type="button" aria-label="Next review" class="is-active">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                <path
                  d="M9 5L16 12L9 19"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </header>

      <div class="sav-reviews-track">
        <article class="sav-review-card">
          <div class="sav-review-card-top">
            <div class="sav-review-stars" aria-hidden="true">★★★★★</div>
            <h4>Saved 50% on My Order</h4>
          </div>
          <p>
            "Applied the coupon at checkout and it worked instantly. Great savings and no hassle.
            This has become my go-to for verified deals."
          </p>
          <div class="sav-review-card-foot">
            <div class="sav-review-card-user">
              <span aria-hidden="true">GU</span>
              <div>
                <strong>Guest User</strong>
                <small>on Zaful</small>
              </div>
            </div>
            <p>Sep 9, 2026</p>
          </div>
        </article>

        <article class="sav-review-card">
          <div class="sav-review-card-top">
            <div class="sav-review-stars" aria-hidden="true">★★★★★</div>
            <h4>Seamless Integration</h4>
          </div>
          <p>
            "Exactly what was promised. The codes actually work and the interface is so much cleaner
            than typical coupon aggregators."
          </p>
          <div class="sav-review-card-foot">
            <div class="sav-review-card-user">
              <span aria-hidden="true">EH</span>
              <div>
                <strong>Elena Holst</strong>
                <small>Verified Shopper</small>
              </div>
            </div>
            <p>Sep 12, 2026</p>
          </div>
        </article>

        <article class="sav-review-card">
          <div class="sav-review-card-top">
            <div class="sav-review-stars" aria-hidden="true">★★★★★</div>
            <h4>Top Notch Support</h4>
          </div>
          <p>
            "Had a quick question about a partner deal and the response was almost immediate.
            Professional and high quality service."
          </p>
          <div class="sav-review-card-foot">
            <div class="sav-review-card-user">
              <span aria-hidden="true">MT</span>
              <div>
                <strong>Marcus Thorne</strong>
                <small>Elite Member</small>
              </div>
            </div>
            <p>Oct 02, 2026</p>
          </div>
        </article>
      </div>

      <div class="sav-reviews-cta">
        <button type="button">Write a Review</button>
      </div>
    </section>

    <app-latest-insights />
  </div>
</section>
